
    import __i18nConfig from '@next-translate-root/i18n.json'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    import useLocale from 'next-translate/useTranslation';
import React, { useEffect, useState } from 'react';
import TextareaAutosize from 'react-textarea-autosize';
import { copyTextToClipboard } from '@/lib/copyTextToClipboard';
import Button from '@/components/buttons/Button';
import CallToAction from '@/components/CallToAction';
import Features2 from '@/components/Features2';
import Footer from '@/components/layout/Footer';
import LandingPageNavigation from '@/components/layout/LandingPageNavigation';
import Seo from '@/components/Seo';
const CaseConverterTool = () => {
    const [text, setText] = useState('');
    const [caseType, setCaseType] = useState('Title Case');
    const { t } = useLocale('free-tools');
    const handleClear = () => setText('');
    useEffect(() => {
        handleCaseConversion();
    }, [caseType, text]);
    const handleCaseConversion = () => {
        switch (caseType) {
            case 'Title Case':
                setText(text.replace(/\w\S*/g, (txt) => txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase()));
                break;
            case 'Sentence Case':
                setText(text.replace(/(^\s*\w|[.!?]\s*\w)/g, (letter) => letter.toUpperCase()));
                break;
            case 'Capital Case':
                setText(text.replace(/\b\w/g, (letter) => letter.toUpperCase()));
                break;
            case 'Uppercase':
                setText(text.toUpperCase());
                break;
            case 'Lowercase':
                setText(text.toLowerCase());
                break;
            default:
                break;
        }
    };
    return (<main className='relative bg-gray-100 dark:bg-slate-900'>
      <Seo templateTitle={t('Case Converter Tool')} description={t('Use our free case converter tool to convert the case of your text.')} image={`https://easy-peasy.ai/api/og-template?title=${t('Case Converter Tool')}
          &description=${t('Use our free case converter tool to convert the case of your text.')}`}/>
      <div className='relative overflow-hidden bg-white dark:bg-slate-900'>
        <div className='mx-auto'>
          <LandingPageNavigation />
          <div className='relative z-10 bg-white pb-8 dark:bg-slate-900  lg:w-full'>
            <div className='relative  bg-white dark:bg-slate-900'>
              <div className='mx-auto'>
                <main className='mx-auto mt-16 max-w-7xl px-4 sm:mt-24 sm:px-6 lg:mt-32'>
                  <div className=''>
                    <div className='relative z-30 text-center md:mx-auto'>
                      <h1>
                        <span className='rounded bg-primary-50 px-2.5 py-1 text-xl font-semibold text-primary-600 dark:bg-slate-800'>
                          {t('Case Converter Tool')}
                        </span>
                        <span className='mt-1 block text-4xl font-bold tracking-tight sm:text-5xl '>
                          <span className='block text-gray-900 dark:text-slate-200'>
                            {t('Convert your text case')}
                          </span>
                          <span className='block text-primary-600'>
                            {t('with our free tool')}
                          </span>
                        </span>
                      </h1>
                      <p className='mt-3 text-base text-gray-500 sm:mt-5 sm:text-xl lg:text-lg xl:text-xl'>
                        {t('Use our free case converter tool to convert the case of your text.')}
                      </p>
                    </div>
                  </div>
                  <div className='flex mt-12'>
                    <TextareaAutosize value={text} onChange={(e) => setText(e.target.value)} className='block w-full rounded-md border-gray-300 shadow-sm focus:border-primary-500 focus:ring-primary-500 dark:border-white/5 dark:bg-slate-700/50 dark:text-white sm:text-sm' rows={18} minRows={19} maxRows={36} placeholder={t('Enter your text here')}/>
                    <div className='w-1/4 ml-4'>
                      <select value={caseType} onChange={(e) => setCaseType(e.target.value)}>
                        <option value='Title Case'>{t('Title Case')}</option>
                        <option value='Sentence Case'>
                          {t('Sentence Case')}
                        </option>
                        <option value='Capital Case'>
                          {t('Capital Case')}
                        </option>
                        <option value='Uppercase'>{t('Uppercase')}</option>
                        <option value='Lowercase'>{t('Lowercase')}</option>
                      </select>
                    </div>
                  </div>
                  <div className='mt-4'>
                    <Button onClick={() => copyTextToClipboard(text)} variant='outline'>
                      {t('Copy to Clipboard')}
                    </Button>
                    <Button onClick={handleClear} color='red' className='ml-4' variant='outline'>
                      {t('Clear Text')}
                    </Button>
                  </div>
                </main>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className=' bg-white py-20 px-5 dark:bg-slate-900'>
        <div className='mx-auto max-w-md px-4 text-center sm:max-w-3xl sm:px-6 lg:max-w-7xl lg:px-8'>
          <h2 className='text-3xl font-semibold text-indigo-600'>
            {t('Other Free Tools')}
          </h2>
          <Features2 showAll={true} isFree={true}/>
        </div>
      </div>

      <CallToAction />
      <Footer />
    </main>);
};
export default CaseConverterTool;

    async function __Next_Translate__getStaticProps__1a11b03d4a5__(ctx) {
      if (typeof global !== 'undefined') {
        global.i18nConfig = __i18nConfig
      }
      
      return {
        
        
        props: {
          
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: '/free-tools/case-converter',
            loaderName: 'getStaticProps',
            loadLocaleFrom: __i18nConfig && __i18nConfig.loadLocaleFrom || ((l, n) => import('../../../locales/' + l + '/' + n).then(m => m.default)),
          }))
        }
      }
    }
    export { __Next_Translate__getStaticProps__1a11b03d4a5__ as getStaticProps }
  